import React from 'react';
import BulkActionButton from './action_button';

const ActionBarBulkActions = ({ actions, selectedCount, buttons }) => {
  const renderModalMessage = message => {
    const toReplace = {
      '%selectedCount%': selectedCount,
      '%nItems%': selectedCount > 1 ? 'items' : 'item',
    };

    return typeof message === 'string'
      ? message.replace(/%selectedCount%|%nItems%/gi, token => toReplace[token])
      : message;
  };

  return (
    <div className="Index-toolbarActions">
      {buttons.map(button => (
        <BulkActionButton
          {...button}
          key={button.onClickKey}
          onClick={actions[button.onClickKey]}
          modalMessage={renderModalMessage(button.modalMessage)}
        />
      ))}
    </div>
  );
};

ActionBarBulkActions.defaultProps = {
  buttons: [],
};

export default ActionBarBulkActions;
